import React from 'react';
import { FormikProps } from 'formik';

import { INITIAL_VALUES } from '../utils/validateForm';

import * as S from '../styles';
import ValidationDocument from '../../../../../components/ValidationDocument';
import { Dropdown } from '../../../../../components/Dropdown';
import { isOlderThan, onlyLetters, validateDate, validateEmail, validateName } from '../../../../../utils/validators';
import { maskPhone, maskStringDate } from '../../../../../utils/masks';
import { default as InputText } from '../../../../../components/Input';

type PatientForm = {
  formik: FormikProps<typeof INITIAL_VALUES>;
};

export const PatientForm: React.FC<PatientForm> = ({ formik }) => {
  const [validDocument, setValidDocument] = React.useState(true);

  return (
    <>
      <ValidationDocument
        setFieldValue={formik.setFieldValue}
        setFieldError={formik.setFieldError}
        document={formik.values.document}
        documentType={formik.values.documentType}
        error={formik.errors.document}
        setIsValid={setValidDocument}
        isValid={validDocument}
        onConfirmIdentity={() => {}}
        showConfirmIdentity={false}
      />
      <>
        <S.FieldWrapper>
          <Dropdown
            value={formik.values.citizenship}
            label="Nacionalidade"
            placeholder="Nacionalidade"
            options={['Brasileiro', 'Estrangeiro']}
            onSelect={value => {
              formik.setFieldValue('citizenship', value);
              formik.setFieldError('citizenship', '');
            }}
            error={formik.errors.citizenship}
          />
        </S.FieldWrapper>
        <S.FieldWrapper>
          <InputText
            name="name"
            id="name"
            placeholder="Nome"
            label="Nome"
            onChange={e => {
              const nameOnlyLetters = onlyLetters(e.target.value);
              formik.setFieldValue('name', nameOnlyLetters);
              if (!validateName(nameOnlyLetters)) {
                formik.setFieldError('name', 'Digite nome completo');
              } else {
                formik.setFieldError('name', '');
              }
            }}
            value={formik.values.name}
            error={formik.errors.name}
          />
        </S.FieldWrapper>
        <S.FieldWrapper>
          <InputText
            name="birthDateDate"
            id="birthDateDate"
            label="Data de nascimento"
            placeholder="Data de nascimento"
            maxLength={10}
            onChange={e => {
              const dateStringMasked = maskStringDate(e.currentTarget.value);
              formik.setFieldValue('birthDateDate', dateStringMasked);
              const dateString = validateDate(dateStringMasked);
              if (dateStringMasked.length < 10 || !dateString) {
                formik.setFieldError('birthDateDate', 'Data inválida');
              } else {
                formik.setFieldError('birthDateDate', '');
                formik.setFieldValue('birthDate', dateString);
              }
            }}
            value={formik.values.birthDateDate}
            error={formik.errors.birthDateDate}
          />
        </S.FieldWrapper>
        <S.FieldWrapper>
          <Dropdown
            value={formik.values.gender}
            label="Sexo"
            placeholder="Sexo"
            options={['Masculino', 'Feminino']}
            onSelect={value => {
              formik.setFieldValue('gender', value);
              formik.setFieldError('gender', '');
              if (value === 'Masculino') {
                formik.setFieldValue('pregnant', '');
              }
            }}
            error={formik.errors.gender}
          />
        </S.FieldWrapper>
        {formik.values.gender === 'Feminino' && isOlderThan(formik.values.birthDate, 9) && (
          <S.FieldWrapper>
            <Dropdown
              value={formik.values.pregnant}
              label="Gestante"
              placeholder="É gestante?"
              options={['Sim', 'Não']}
              onSelect={value => {
                formik.setFieldValue('pregnant', value);
                formik.setFieldError('pregnant', '');
              }}
              error={formik.errors.pregnant}
            />
          </S.FieldWrapper>
        )}
        <S.FieldWrapper>
          <InputText
            name="email"
            placeholder="Email"
            label="Email"
            type="text"
            onChange={e => {
              const email = e.target.value;
              formik.setFieldValue('email', email);
              if (!validateEmail(email)) {
                formik.setFieldError('email', 'Digite um email válido');
              } else {
                formik.setFieldError('email', '');
              }
            }}
            value={formik.values.email}
            error={formik.errors.email}
          />
        </S.FieldWrapper>
        <S.FieldWrapper>
          <InputText
            name="phone"
            placeholder="Telefone"
            label="Telefone"
            type="text"
            onChange={e => {
              const maskedPhone = maskPhone(e.target.value);
              formik.setFieldValue('phone', maskedPhone);
              if (maskedPhone.length < 13) {
                formik.setFieldError('phone', 'Telefone inválido');
              } else {
                formik.setFieldError('phone', '');
              }
            }}
            value={formik.values.phone}
            error={formik.errors.phone}
          />
        </S.FieldWrapper>
      </>
    </>
  );
};
